if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.runtime.common.prod.js')
} else {
  module.exports = require('./vue.runtime.common.dev.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/vue/dist/vue.runtime.common.js
// module id = 81
// module chunks = 104